import React from 'react';
export const usePagination = (rows, rowsPerPageOptionValues = [5, 10, 25]) => {
    const [currentPageNumber, setCurrentPageNumber] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(Math.min(...rowsPerPageOptionValues));
    const handleChangePage = React.useCallback((event, newPageNumber) => {
        setCurrentPageNumber(newPageNumber);
    }, []);
    const handleChangeRowsPerPage = React.useCallback((event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setCurrentPageNumber(0);
    }, []);
    const currentPageRows = rows.slice(currentPageNumber * rowsPerPage, currentPageNumber * rowsPerPage + rowsPerPage);
    if (currentPageNumber > 0 && currentPageRows.length === 0) {
        handleChangePage(null, currentPageNumber - 1);
    }
    return {
        currentPageRows,
        currentPageNumber,
        rowsPerPage,
        rowsPerPageOptionValues,
        handleChangePage,
        handleChangeRowsPerPage,
    };
};
